import style from "./index.module.scss";
import { Outlet, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "@/styles/cabinet.scss";
import { Alert } from "@/components/Alert";
import { getSubAccountStratum$, setShowModal } from "@/store/sub_accounts";
import { RootState, useAppDispatch } from "@/store";
import { useAuth, useSubAccount } from "@/hooks";
import { useSelector } from "react-redux";
import { getEarningOptions$ } from "@/store/references";
import { AddSubAccountDialog, CabinetStatrumUrlsComponent } from "@/features";
import { USER_INFO, USER_TOKEN } from "@/variables";
import { refreshToken, verifySend } from "@/store/auth/api";
import { customFetch } from "@/utils/custom-fetch";
import { decodeToken } from "react-jwt";

export function CabinetLayout() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const dispatch = useAppDispatch();
  const { setUserStore } = useAuth();
  const { currentSubAccount } = useSubAccount();
  const showModal = useSelector(
    (state: RootState) => state.subAccount.showModal,
  );
  const earningOptions = useSelector(
    (state: RootState) => state.references.earningOptions,
  );
  const checkVerification = () => {
    const token = JSON.parse(
      localStorage.getItem(USER_INFO) || JSON.stringify({}),
    );
    if (token) {
      if (!token.user?.is_email_verified) {
        const tokenStorage = localStorage.getItem(USER_TOKEN);
        const currentToken = tokenStorage ? JSON.parse(tokenStorage) : {};
        refreshToken({ refresh: currentToken?.refresh }).then((user) => {
          const data: any = decodeToken(user.access);
          if (data) {
            data.created_date = new Date().toISOString();
          }
          localStorage.setItem(USER_INFO, JSON.stringify(data));
          localStorage.setItem(USER_TOKEN, JSON.stringify(user));
          customFetch.defaults.headers.common["Authorization"] =
            `Bearer ${user.access}`;
          setUserStore(user).then(() => {
            if (data.user?.is_email_verified) {
              navigate("/cabinet/statistics");
            } else {
              verifySend(token.user?.email).then(() => {
                navigate("/verify");
              });
            }
          });
        });
      }
    }
  };
  useEffect(() => {
    if (currentSubAccount) {
      dispatch(getSubAccountStratum$(currentSubAccount)).unwrap();
    }
    if (!earningOptions?.length) {
      dispatch(getEarningOptions$());
    }

    checkVerification();
  }, [currentSubAccount]);
  return (
    <section className={style.cabinetLayout}>
      {showModal && (
        <AddSubAccountDialog onClose={() => dispatch(setShowModal(false))} />
      )}
      <div>
        {alert && (
          <Alert
            text={"Скопировано"}
            onClose={() => {
              setAlert(false);
            }}
          />
        )}
        <div className={style.cabinetLayout__content}>
          <Outlet />
        </div>
      </div>
      <CabinetStatrumUrlsComponent />
    </section>
  );
}
